var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const Svg404 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.997 74.6124C159.997 91.3183 153.174 106.377 142.233 117.201C131.527 127.906 116.703 134.377 100.35 134.377C84.1149 134.377 69.2914 127.789 58.4678 117.201C47.5267 106.377 40.7031 91.3183 40.7031 74.6124C40.7031 41.5535 67.409 14.8477 100.35 14.8477C133.291 14.8477 159.997 41.6712 159.997 74.6124Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.824 35.4322C157.487 35.4322 159.647 33.2726 159.647 30.6087C159.647 27.9447 157.487 25.7852 154.824 25.7852C152.16 25.7852 150 27.9447 150 30.6087C150 33.2726 152.16 35.4322 154.824 35.4322Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.88 16.6117C163.699 16.6117 165.174 15.1368 165.174 13.3176C165.174 11.4983 163.699 10.0234 161.88 10.0234C160.061 10.0234 158.586 11.4983 158.586 13.3176C158.586 15.1368 160.061 16.6117 161.88 16.6117Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5871 35.3148C44.4064 35.3148 45.8812 33.84 45.8812 32.0207C45.8812 30.2014 44.4064 28.7266 42.5871 28.7266C40.7678 28.7266 39.293 30.2014 39.293 32.0207C39.293 33.84 40.7678 35.3148 42.5871 35.3148Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4692 98.8486C25.8479 98.8486 28.5869 96.1096 28.5869 92.7309C28.5869 89.3523 25.8479 86.6133 22.4692 86.6133C19.0905 86.6133 16.3516 89.3523 16.3516 92.7309C16.3516 96.1096 19.0905 98.8486 22.4692 98.8486Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27471_203104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.666 40.3544V105.537C153.666 108.249 151.495 110.399 148.832 110.399H50.6501C47.988 110.399 45.7812 108.214 45.7812 105.537V40.3544C45.7812 37.6767 47.953 35.4922 50.6501 35.4922H148.832C151.495 35.4922 153.666 37.6767 153.666 40.3544Z",
    fill: "url(#paint0_linear_27471_203104)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.666 40.3544V47.6478H45.7812V40.3544C45.7812 37.6767 47.953 35.4922 50.6501 35.4922H148.832C151.495 35.4922 153.666 37.6767 153.666 40.3544Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5792 43.383C53.5852 43.383 54.4007 42.5628 54.4007 41.5509C54.4007 40.539 53.5852 39.7188 52.5792 39.7188C51.5733 39.7188 50.7578 40.539 50.7578 41.5509C50.7578 42.5628 51.5733 43.383 52.5792 43.383Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5324 43.383C59.5383 43.383 60.3538 42.5628 60.3538 41.5509C60.3538 40.539 59.5383 39.7188 58.5324 39.7188C57.5264 39.7188 56.7109 40.539 56.7109 41.5509C56.7109 42.5628 57.5264 43.383 58.5324 43.383Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4542 43.383C65.4602 43.383 66.2757 42.5628 66.2757 41.5509C66.2757 40.539 65.4602 39.7188 64.4542 39.7188C63.4483 39.7188 62.6328 40.539 62.6328 41.5509C62.6328 42.5628 63.4483 43.383 64.4542 43.383Z",
    fill: "#989FB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3047 92.0469H131.144",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2188 98.7734H121.233",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2206 73.0906V76.7196H87.0139V80.2077H82.8806V76.7196H73.7734V72.5621L82.2151 60.7588H87.0489V73.1258H89.2206V73.0906ZM82.8806 65.5858L77.6265 73.0906H82.8806V65.5858Z",
    fill: "url(#paint1_linear_27471_203104)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5888 80.5953C95.1753 80.5953 91.2872 76.7196 91.2872 70.448C91.2872 64.1765 95.1403 60.3008 99.5888 60.3008C104.037 60.3008 107.89 64.1765 107.89 70.448C107.89 76.7196 104.037 80.5953 99.5888 80.5953ZM99.5888 76.8605C101.655 76.8605 103.722 74.7818 103.722 70.4833C103.722 66.1848 101.655 64.106 99.5888 64.106C97.5221 64.106 95.4555 66.1848 95.4555 70.4833C95.4555 74.7818 97.5221 76.8605 99.5888 76.8605Z",
    fill: "url(#paint2_linear_27471_203104)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.719 73.0906V76.7196H123.513V80.2077H119.379V76.7196H110.272V72.5621L118.714 60.7588H123.548V73.1258H125.719V73.0906ZM119.344 65.5858L114.09 73.0906H119.344V65.5858Z",
    fill: "url(#paint3_linear_27471_203104)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.896 124.793L125.43 101.345L130.809 95.9648L154.258 119.432L148.896 124.793Z",
    fill: "#858B9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.051 133.04L139.057 115.046C137.554 113.543 137.554 111.094 139.057 109.592C140.559 108.089 143.008 108.089 144.511 109.592L162.505 127.586C164.008 129.089 164.008 131.537 162.505 133.04C161.002 134.543 158.554 134.543 157.051 133.04Z",
    fill: "#858B9B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.774 134.193L132.622 111.041C132.084 110.504 132.084 109.632 132.622 109.075L138.54 103.157C139.078 102.619 139.95 102.619 140.506 103.157L163.658 126.309C164.196 126.847 164.196 127.719 163.658 128.275L157.74 134.193C157.184 134.731 156.312 134.731 155.774 134.193Z",
    fill: "url(#paint4_linear_27471_203104)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8648 25.7852C74.3035 25.7852 54.3984 45.6902 54.3984 70.2515C54.3984 94.7942 74.3035 114.718 98.8462 114.718C123.408 114.718 143.313 94.8128 143.313 70.2515C143.313 45.6902 123.408 25.7852 98.8648 25.7852ZM98.8648 106.481C79.1452 106.481 63.173 90.2493 63.173 70.2329C63.173 50.2166 79.1452 34.0032 98.8648 34.0032C118.584 34.0032 134.557 50.2351 134.557 70.2515C134.557 90.2678 118.566 106.481 98.8648 106.481Z",
    fill: "url(#paint5_linear_27471_203104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27471_203104",
    x: 23.7812,
    y: 24.4922,
    width: 151.887,
    height: 118.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27471_203104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27471_203104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27471_203104",
    x1: 99.6886,
    y1: 33.7595,
    x2: 99.6886,
    y2: 111.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27471_203104",
    x1: 108.079,
    y1: 60.3008,
    x2: 111.96,
    y2: 80.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27471_203104",
    x1: 108.079,
    y1: 60.3008,
    x2: 111.96,
    y2: 80.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27471_203104",
    x1: 108.079,
    y1: 60.3008,
    x2: 111.96,
    y2: 80.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27471_203104",
    x1: 132.204,
    y1: 118.679,
    x2: 164.067,
    y2: 118.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27471_203104",
    x1: 54.3577,
    y1: 70.2611,
    x2: 143.329,
    y2: 70.2611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg404, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/404.8f14e366.svg";
export { ForwardRef as ReactComponent };